<template>
    <div class="ccpay-ordetail">
        <div class="ccpay-order-header">
            <span @click="back">退後</span>
            <span>訂單详情</span>
            <span><ChatWindow :title="`訂單反馈`" /></span>
        </div>
        <div class="ccpay-order-connect">
            <ul style="padding: 1rem;" v-if="data">
                <li>
                    <p>
                        <span>
                            <b>訂單编号 </b>
                        </span>
                        <span> ：{{ data.order_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.order_no" @click="copy">复制</span>
                    </p>
                </li>
                <li>
                    <p>
                        <span>
                            <b>訂單時間</b> ：{{ data.created_time }}
                        </span>
                        <!-- <span></span> -->
                        <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.name" @click="copy">复制</span> -->
                    </p>
                </li>
                <li v-if="data.status != 'COMPLETE'">
                    <p>
                        <span>
                            <b>訂單倒计时</b> ：<span>{{ this.restStr }}</span>
                        </span>
                        <!-- <span></span> -->
                        <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.name" @click="copy">复制</span> -->
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>姓名</b> ：<a :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{ data.name
                            }}</a>
                        </span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.name" @click="copy">复制</span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>交割状态</b> ：<a :style="{ 'color': getStatusColor() }">{{ getStatusText() }}</a>
                        </span>
                    </p>
                </li>






                <li class="bg-f-w">
                    <p>
                        <span class="detail-spo" style="margin-bottom:0rem">
                            <span>
                                <b>转账金额 </b>：<a :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{
                                    data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0] }} 元
                                    <!--{{data.legal_currency}} --></a>
                                &nbsp;&nbsp;<span class="fl-r tag-read"
                                    :data-clipboard-text="data.legal_amount.toString().match(/^\d+(?:\.\d{0,4})?/)[0]"
                                    @click="copy">复制</span>
                            </span>
                            <span style="float:right"> <b>类型 </b>：<a
                                    :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{ data.side == 'BUY' ?
                                        '买单' : '卖单' }}
                                </a></span>
                        </span>
                        <!-- <span class="fl-r tag-read" 
                        :data-clipboard-text="data.legal_currency" @click="copy">复制</span> -->
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>交割数量</b> ：<a :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{
                                parseFloat(Number(data.amount)) }} USDT(泰达币)
                                <!--  {{data.currency}} --></a>
                            <span style="float:right"> <b>单价 </b>：<a
                                    :style="{ 'color': data.side == 'BUY' ? '#54BCA5' : '#CA595B' }">{{
                                        toFixed(data.coin_price, 2) }} CNY
                                </a></span>
                        </span>
                    </p>
                </li>

                <li class="bg-f-w" v-show="data.status === 'COMPLETE'">
                    <p>
                        <span>
                            <b>交割明细</b> ：<span style="color:#26a2ff" @click="goToDeliveryDetail">查看</span>
                        </span>
                    </p>
                </li>

                <li class="bg-f-w">
                    <p>
                        <span>
                            <b>交易员姓名</b> ：{{ data.name || '通道验证' }}
                        </span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.name || '通道验证'" @click="copy">复制</span>
                    </p>
                </li>
                <li v-show="paytypeflag" style="padding-top:1rem;padding-bottom:1rem">
                    <p>
                        <span style="color:#26a2ff" @click="paytype = !paytype"> 切换支付方式</span>
                    </p>
                </li>
                <li v-show="data.bank_account_name && paytype">
                    <p>

                        <span> <b>銀行卡姓名 </b>：{{ data.bank_account_name }}</span>

                        <span class="fl-r tag-read" :data-clipboard-text="data.bank_account_name" @click="copy">复制</span>
                    </p>
                </li>
                <li v-show="data.bank_name && paytype">
                    <p>
                        <span><b>銀行名稱 </b>：{{ data.bank_name }}</span>
                        <!-- <span> </span> -->
                        <!--   <span class="fl-r tag-read" 
                        :data-clipboard-text="data.bank_name" @click="copy">复制</span>  -->
                    </p>
                </li>
                <li v-show="data.bank_branch_name && paytype">
                    <p>
                        <span class="detail-spo"><b>銀行地址 </b></span>
                        <span>{{ data.bank_branch_name }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.bank_branch_name" @click="copy">复制</span>
                    </p>
                </li>
                <li v-show="data.bank_account_no && paytype">
                    <p>
                        <span class="detail-spo"><b>銀行卡号 </b></span>
                        <span>{{ data.bank_account_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.bank_account_no" @click="copy">复制</span>
                    </p>
                </li>
                <li v-show="data.alipay_account_name && !paytype">
                    <p>
                        <span>
                            <b>支付寶姓名</b>：{{ data.alipay_account_name }}
                        </span>
                        <span></span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.alipay_account_name" @click="copy">复制</span>
                    </p>
                </li>
                <li class="bg-f-w" v-show="data.alipay_account_no && !paytype">
                    <p>
                        <span class="detail-spo"><b>支付寶帳號 </b></span>
                        <span>{{ data.alipay_account_no }}</span>
                        <span class="fl-r tag-read" :data-clipboard-text="data.alipay_account_no" @click="copy">复制</span>
                    </p>

                </li>

                <li class="bg-f-w" v-if="data.payment_proofs && data.payment_proofs.length > 0">
                    <div style="width: 100%;">
                        <p style="margin-bottom: 0.5rem;">
                            <b>付款凭证</b>
                        </p>
                        <div class="proof-imgs">
                            <img v-for="(item, index) in data.payment_proofs" 
                                :key="index" 
                                :src="item.url" 
                                class="proof-thumb"
                                @click.stop="previewImage = item.url"
                            />
                        </div>
                    </div>
                </li>
                <!-- <div v-show="data.alipay_account_name&&!this.data.bank_account_name">
                       <mt-button
                         class="mt-40" size="large" type="primary" 
                         @click="emit('user',data.order_no)">放行</mt-button>
                 </div> -->
                <!-- 客户放行 -->
                <!-- <mt-button class="bg-f-b mt-40" v-show="data.side == 'SELL' && data.status == 'CREATED'" size="large"
                    type="primary" @click="emit('user', data.order_no)">我已付款</mt-button> -->
                <mt-button class="bg-f-b mt-40" v-show="data.side == 'SELL' && data.status == 'CREATED'" size="large"
                    type="primary" @click="toSubmitSellFile()">提交流水证明</mt-button>
                <!-- <mt-button class="bg-f-b mt-40" v-show="data.side == 'SELL' && data.status == 'CREATED'" size="large"
                    type="primary" @click="changeorder(data.order_no)">转单</mt-button> -->
                <!-- 交易员放行 -->
                <mt-button class="bg-f-b mt-40"
                    v-show="data.side == 'BUY' && data.status == 'PAID' || data.side == 'BUY' && data.status == 'CREATED'"
                    size="large" type="primary" @click="Unknownpayment('pople', data.order_no)">放行</mt-button>
            </ul>
        </div>
        <div v-if="previewImage" class="img-preview-overlay" @click="previewImage = null">
            <img :src="previewImage" class="preview-full-img" />
        </div>
    </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { toFixed, Formatnumbers } from '../../public/index.js'
import ChatWindow from '../../component/ChatWindow.vue';
import Clipboard from 'clipboard';
import moment from "moment"
export default {
    components: {
        ChatWindow
    },
    data() {
        return {
            data: null,
            paytype: true,
            paytypeflag: false,
            restTimer: null,//訂單倒计时
            restStr: '',
            previewImage: null
        }
    },
    mounted() {
        let id = this.$route.query.orderid
        this.$axios(`/v1/traders/order/detail?order_no=${id}`).then(res => {
            if (res.code == 0) {
                this.data = res.data
                this.restTime(res.data.plan_end_time)
                if (res.data.bank_name) {
                    this.paytype = true
                } else {
                    this.paytype = false
                }
                if (res.data.bank_name && res.data.alipay_account_name) {
                    this.paytypeflag = true
                } else {
                    this.paytypeflag = false
                }
                //    console.log(res.data)
            }

        })
    },
    destroyed() {
        clearInterval(this.restTimer)
    },
    methods: {
        Formatnumbers,
        toFixed,
        moment,
        back() {
            this.$router.go(-1)
        },

        restTime(time) {

            this.restTimer = setInterval(() => {

                var settime = moment(time).valueOf()
                var nowtime = moment().valueOf()

                var restsec = settime - nowtime
                if (restsec < 0) {
                    return this.restStr = '已超时'
                }
                var minu = parseInt((restsec / (60 * 1000)) % 60);
                var sec = parseInt((restsec / 1000) % 60);
                this.restStr = minu + ":" + this.zero(sec);

            }, 1000)

        },
        zero(sec) {
            if (sec < 10) {
                return "0" + sec;
            } else {
                return sec;
            }
        },
        //二次提示付款
        Unknownpayment(type, id) {
            // data.status=='PAID'
            this.$MessageBox.confirm('', {
                title: '提示',
                message: '请确认该訂單已收款！',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(action => {
                this.emit(type, id)
                //    console.log('确定'); 
            }).catch(error => {

                //   console.log('取消'); 
            })
        },
        toSubmitSellFile() {
            this.$router.push({
                path: `/sub_sell_order_file?orderid=${this.$route.query.orderid}`
            })
        },
        // 跳转到交割详情页面
        goToDeliveryDetail() {
            this.$router.push({
                path: `/DeliveryOrderDetail?orderid=${this.$route.query.orderid}`
            })
        },
        
        // 获取状态文本
        getStatusText() {
            if (!this.data) return ''
            const statusMap = {
                'CREATED': '已创建',
                'PAID': '已付款',
                'COMPLETE': '交割完成',
                'CANCELLED': '已取消',
                'TIMEOUT': '已超时'
            }
            return statusMap[this.data.status] || this.data.status
        },
        
        // 获取状态颜色
        getStatusColor() {
            if (!this.data) return '#333'
            const colorMap = {
                'COMPLETE': '#54BCA5',  // 绿色
                'PAID': '#FF9500',      // 橙色
                'CREATED': '#26a2ff',   // 蓝色
                'CANCELLED': '#CA595B', // 红色
                'TIMEOUT': '#CA595B'    // 红色
            }
            return colorMap[this.data.status] || '#333'
        },
        //选择放行方式  一个或者两个    
        emit(type, id) {

            if (this.data.alipay_account_name && this.data.bank_account_name) {
                this.bothsides(type, id)
                return
            }
            if (this.data.alipay_account_name) {//支付寶
                this.pay(type, id)
                return
            }

            //  console.log('?????')
            if (this.data.bank_name) {//銀行
                this.Bank(type, id)

                return
            }
        },
        //支付寶或銀行卡
        bothsides(type, id) {
            let code, tit;
            if (type == 'user') {
                code = 'paid'
                tit = `请选择您的放行方式 `
            } else {
                code = 'recived'
                tit = `请选择您的放行方式 `
            }
            // console.log(code,'codecode')
            this.$MessageBox.confirm('', {
                title: '提示',
                message: tit,
                confirmButtonText: '銀行卡',
                cancelButtonText: '二维码'
            }).then(action => {
                this.Release('BANKPAY', code, id)
                //    console.log('銀行卡'); 
            }).catch(error => {
                this.Release('ALIPAY', code, id)
                //   console.log('支付寶'); 
            })
        },

        //支付寶
        pay(type, id) {
            let code
            if (type == 'user') {
                code = 'paid'
            } else {
                code = 'recived'
            }
            this.$MessageBox.confirm('', {
                title: '提示',
                message: '當前放行帳號为二维码帳戶',
                confirmButtonText: '请确定放行',
                cancelButtonText: '取消',
                showCancelButton: false
            }).then(action => {
                this.Release('ALIPAY', code, id)
            }).catch(error => {

            })
        },
        //銀行卡
        Bank(type, id) {

            let code;
            if (type == 'user') {
                code = 'paid'
            } else {
                code = 'recived'
            }
            this.$MessageBox.confirm('', {
                title: '提示',
                message: '當前放行帳號为銀行卡帳戶',
                confirmButtonText: '请确定放行',
                cancelButtonText: '取消',
                showCancelButton: false
            }).then(action => {
                this.Release('BANKPAY', code, id)
            }).catch(error => {

            })
        },
        //放行
        Release(type, code, id) {

            Indicator.open();
            this.$axios.post(`/v1/traders/order/${code}`, {
                "account_type": type,
                "order_no": id
            }).then(res => {
                Indicator.close();
                if (res.code == 0) {
                    this.$Toast('标记付款成功')
                    this.back()
                } else {
                    this.$Toast(res.msg)
                    this.back()
                }
            })
        },
        changeorder(id) {

            this.$MessageBox.confirm('', {
                title: '提示',
                message: '您是否确定转单',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                showCancelButton: true
            }).then(action => {
                Indicator.open();
                this.$axios.post('/v1/traders/order/transfer', {
                    "order_no": id,
                }).then(res => {
                    Indicator.close();
                    if (res.code == 0) {
                        this.$Toast('转单成功')
                        this.back()
                    } else {
                        this.$Toast(res.msg)
                        this.back()
                    }
                })
            }).catch(error => {

            })



        },
        copy() {
            var clipboard = new Clipboard('.tag-read')
            clipboard.on('success', e => {
                //           console.log('复制成功')
                this.$Toast('复制成功')
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$Toast('该浏览器不支持自动复制')
                //           console.log('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.ccpay-ordetail {
    b {
        font-weight: 400;
    }
}

.card-css {}

.gr76 {
    color: rgb(76, 175, 80)
}

.gred {
    color: red;
}

.bg-f-w {
    -webkit-transform: translateZ(0px);
    transform: translateZ(0px);
    font-size: 14px;
    // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
    // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
    // border-radius: 8px;
    // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;
}

.bg-f-b {
    padding: 1.5rem;
    line-height: 0rem;
    // background-color: dimgrey;

    -webkit-transform: translateZ(0px);
    transform: translateZ(0px);
    font-size: 14px;
    // -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
    // box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
    // // border-radius: 8px;
    // transition: transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s, -webkit-transform 500ms cubic-bezier(0.12, 0.72, 0.29, 1) 0s;

}

.ccpay-ordetail {

    height: 100%;
    background: white;

    // padding-top: 3rem;
    .ccpay-order-header {
        position: fixed;
        top: 0;
        z-index: 999;
        height: 3rem;
        line-height: 3rem;
        width: 100%;
        background: white;
        display: flex;
        justify-content: space-around;
    }

    .ccpay-order-connect {
        padding-top: 3rem;

        ul li {
            border-bottom: 1px solid #eee;
            display: flex;
            font-size: 16px;
            line-height: 1;
            min-height: inherit;
            overflow: hidden;
            padding: 0 10px;
            padding: 1rem;

            p {
                width: 100%;
            }

            .fl-r {
                float: right;
                color: #26a2ff;
            }

            .detail-spo {
                margin-bottom: 1rem;
                min-width: 5.5rem;
                display: inline-block;
                display: flex;
                justify-content: space-between;
            }
        }
    }

    .proof-imgs {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.5rem;
        
        .proof-thumb {
            width: 4rem;
            height: 4rem;
            object-fit: cover;
            margin-right: 0.5rem;
            margin-bottom: 0.5rem;
            border-radius: 4px;
        }
    }
    
    .img-preview-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 3000;
        display: flex;
        align-items: center;
        justify-content: center;
        
        .preview-full-img {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/order/orderdetail.vue